import ResponsiveImage from 'components/Common/ResponsiveImage'
import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  background: linear-gradient(180deg, #DA5E31 3%, #DA3146 23%, #670B0B 100%);
  overflow: hidden;
`

interface Props extends Omit<React.ComponentProps<typeof ResponsiveImage>, 'id' | 'fit'> {
  background: App.SiteTakeoverBackground
}

function MarchTravelFrenzyTakeoverBackground(props: Props) {
  const { className } = props
  return <Container className={className} />
}

export default MarchTravelFrenzyTakeoverBackground
